export default __webpack_public_path__ + "static/media/Neophyte's Bracers of Prestige.86a0e8d4.jpg";